import { QUALIFICATION_CODES } from '../../shared/constants/qualification-code';

export const AIDA_ELIGIBILITY_ERROR_MESSAGES = {
  FEOT: 'Disable FEOT (Field Evenly Over Time)',
  QBP: 'Disable QBP (Quota-Based Pricing)',
  MARGIN_MAX:
    'Turn off the Margin Max feature for this survey, under the "Launch" section.',
  MCSVP:
    'AIDA™ is not available yet with Group Multi-Country. Please use Multi-Surveys instead.',
  ELIGIBLE_QUOTAS:
    'Utilize only one or more (these options can be nested together) of the following quota qualifications: Gender, Age, or Region.',
  ELIGIBLE_QUOTAS_AU:
    'Utilize only one or more (these options can be nested together) of the following quota qualifications: Gender, Age, Region or State.',
  SOFT_LAUNCH: 'Disable Soft Launch',
  PREFER_NOT_TO_SAY:
    "The quota on 'Prefer not to say' in the Gender qualification must be equal to or lower than the census value.",
  AGE_MINIMUM_RANGE: 'The Age quota range must be equal to or greater than 6.',
};

export const AIDA_ALLOWED_QUALIFICATION_CODES = [
  QUALIFICATION_CODES.GENDER,
  QUALIFICATION_CODES.AGE,
  QUALIFICATION_CODES.REGION,
];
